import { errorWrapper } from 'utility/error';

import { apiClient } from './api';

// Sends a delete-suggestion request to Suggestion_Delete. The endpoint
// returns no payload — we only care whether it succeeded.
async function deleteSuggestion(args: {
  tenantId: string;
  suggestionId: string;
}) {
  const { tenantId, suggestionId } = args;

  // Suggestion_Delete returns ApiResult (no data field); pad the shape so it
  // matches what errorWrapper expects.
  const apiCall = apiClient
    .Suggestion_Delete(undefined, { params: { tenantId, suggestionId } })
    .then((res) => ({ ...res, data: undefined }));

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to delete suggestion',
    },
    onSuccess: () => undefined,
  });
}

export { deleteSuggestion };
